import { withChartLayout } from 'components/common';
import SavedPatientTeaching from 'components/features/chart/patient-teaching/saved-patient-teaching/SavedPatientTeaching';

const SavedPatientTeachingPage = withChartLayout('Saved Patient Teaching')(SavedPatientTeaching);
export default SavedPatientTeachingPage;
